import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Star } from 'lucide-react';
const reviews = [{
  name: 'Sarah M.',
  text: 'This school has been amazing for my son. His confidence has grown so much, and he loves coming to class every week. The instructors are fantastic!',
  stars: 5
}, {
  name: 'James T.',
  text: 'I started the adult program to get back in shape, but I found a great community. The workouts are tough but rewarding. Highly recommend!',
  stars: 5
}, {
  name: 'The Rodriguez Family',
  text: "We love the family atmosphere. It's not just about fighting; it's about character. Best decision we made for our daughter.",
  stars: 5
}];
export function Reviews() {
  return <section id="reviews" className="py-24 bg-white" data-id="element-142">
      <div className="container mx-auto px-4" data-id="element-143">
        <div className="text-center mb-16" data-id="element-144">
          <h2 className="text-3xl md:text-5xl font-bold text-neutral-900 mb-4" data-id="element-145">
            What Families Are Saying
          </h2>
          <div className="flex justify-center gap-1 text-yellow-400 mb-4" data-id="element-146">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} fill="currentColor" className="w-6 h-6" data-id="element-147" />)}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-148">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-neutral-50 p-8 rounded-xl shadow-sm border border-neutral-100" data-id="element-149">
              <div className="flex gap-1 text-yellow-500 mb-4" data-id="element-150">
                {[...Array(review.stars)].map((_, i) => <Star key={i} fill="currentColor" className="w-4 h-4" data-id="element-151" />)}
              </div>
              <p className="text-neutral-700 mb-6 italic leading-relaxed" data-id="element-152">
                "{review.text}"
              </p>
              <p className="font-bold text-neutral-900" data-id="element-153">— {review.name}</p>
            </motion.div>)}
        </div>

        <motion.div className="bg-red-700 rounded-2xl p-10 md:p-16 text-center text-white max-w-4xl mx-auto shadow-xl" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-154">
          <p className="text-xl text-red-100 mb-6 font-medium" data-id="element-155">
            Families just like yours started here.
          </p>
          <Button variant="secondary" className="bg-white !text-red-700 hover:bg-gray-100 focus:ring-white" href="/signup" data-id="element-156">
            Ready to Get Started?
          </Button>
        </motion.div>
      </div>
    </section>;
}